import { render, staticRenderFns } from "./cq-super-power.vue?vue&type=template&id=90bdb58a&scoped=true&"
import script from "./cq-super-power.vue?vue&type=script&lang=js&"
export * from "./cq-super-power.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90bdb58a",
  null
  
)

export default component.exports